export var DEFAULT_LOCALE = 'en';
export var LOCALE_COOKIE = 'userLocale';
export var LOCALE_LABELS = {
  'en-US': 'English',
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pt_BR: 'Português',
  pt: 'Português',
  ja_JP: '日本語',
  // Japanese,
  ja: '日本語',
  ko: '한국어',
  // Korean
  ar: 'العربية',
  // Arabic
  ru: 'Русский',
  tr: 'Türkçe',
  // Turkish
  th: 'ไทย',
  // Thai
  pl: 'Polski',
  // Polish
  sv: 'Svenska',
  // Swedish
  fi: 'Suomi',
  // Finnish
  nb: 'Norsk',
  // Norwegian
  da: 'Dansk' // Danish

};
export var RTL_LANGUAGES = ['ar', 'he'];